// React
import React from 'react';
// External libs
import { get } from 'lodash';
// Tools
import { useFormatMessage } from '../../intl/intl';
// Hooks
import Hooks from './hooks';
// Components
import CustomAlert from '../common/custom-alert';
import OrderDetailDialogMainSectionItem from '../order-detail-dialog-main-section-item';
// Styles
import useStyles from './OrderDetailDialogMarketplaceBox.styles';

const OrderDetailDialogMarketplaceBox = () => {
  const componentClasses = useStyles();

  const description = useFormatMessage({
    id: 'orderDetailDialogMarketplaceBox.description',
  });
  const paymentMethodMessage = Hooks.usePaymentMethodAlertMessage();
  const title = useFormatMessage({
    id: 'orderDetailDialogMarketplaceBox.title',
  });

  return (
    <OrderDetailDialogMainSectionItem
      classes={{ body: componentClasses.root }}
      title={title}
    >
      <div className={get(componentClasses, 'description', null)}>
        {description}
      </div>
      <CustomAlert
        classes={{
          root: componentClasses.customAlertPaymentMethodRoot,
        }}
        text={paymentMethodMessage}
      />
    </OrderDetailDialogMainSectionItem>
  );
};

export default OrderDetailDialogMarketplaceBox;
